import { FC, ReactNode, createContext, useContext } from 'react';

type SystemPrototypeDetaisContextType = {
  setEditedSection: (section: string) => void;
};

const defaultSystemPrototypeDetaisContext = null;

export const SystemPrototypeDetaisContext =
  createContext<SystemPrototypeDetaisContextType | null>(
    defaultSystemPrototypeDetaisContext,
  );

export const useSystemPrototypeDetaisContext = () => {
  const contextValue = useContext(SystemPrototypeDetaisContext);

  if (!contextValue) {
    throw new Error(
      'useSystemPrototypeDetaisContext has to be used within <SystemPrototypeDetaisContext.Provider>',
    );
  }

  return contextValue;
};

export const SystemPrototypeDetaisContextProvider: FC<{
  children: ReactNode;
  setEditedSection: (section: string) => void;
}> = ({ children, setEditedSection }) => {
  return (
    <SystemPrototypeDetaisContext.Provider value={{ setEditedSection }}>
      {children}
    </SystemPrototypeDetaisContext.Provider>
  );
};
